export default __webpack_public_path__ + "static/custom-watermark-9e75a6a46a766546ed691106b76b5d0e.png";